export type DataFileContentProfile = 'full' | 'overview';

export const OVERVIEW_CONTENT_VERSION = 'overview-full-gps-v4';

export const TELEMETRY_FILE_LIST_STALE_MS = 5 * 60 * 1000;
export const TELEMETRY_SESSION_STALE_MS = 12 * 60 * 60 * 1000;
